<div class="row align-items-center h-100-vh m--16">
    <div class="col-sm-12 col-md-12 col-lg-6 p-0">
        <img class="w-100 authentication-banner" src="images/login_banner.jpg">
    </div>
    <div class="col-sm-12 col-md-12 col-lg-6 authentication-form authentication-h-100-vh">
        <div class="w-lg-500px h-100-vh">
            <div class="text-center mb-4" (click)="homePage()">
                <img src="images/logo.png" class="app-logo">
            </div>
            <antim-autoware-card>
                <div class="text-center mb-4">
                    <h3 class="text-center authentication-title">Sign In</h3>
                </div>
                <!-- Begin: Sign In form -->
                <form class="validate-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">

                    <!-- Begin: Input field for enter Email ID -->
                    <div class="mb-4">
                        <div class="form-group">
                            <antim-autoware-input [control]="f.emailId" type="text" id="emailId" name="emailId"
                                labelValue="Email ID" [isRequired]="true" placeholder="Please enter Email ID"
                                [ariaAutoComplete]="false" [errorMessage]="getFormErrorMessage(f.emailId)"
                                [inputType]="getFormInputType(f.emailId)"></antim-autoware-input>
                        </div>
                    </div>
                    <!-- End: Input field for enter Email ID -->

                    <!-- Begin: Input field for enter password -->
                    <div class="mb-4">
                        <div class="form-group position-relative">
                            <!-- <span class="position-absolute mx-5 text-primary fw-bold"
                                style="left:45px; cursor: pointer; " (click)="passwordForget()">Forgot
                                Password?</span> -->
                            <antim-autoware-input [control]="f.password" [type]="showPassword ? 'text' : 'password'"
                                id="password" name="password" labelValue="Password"
                                placeholder="Please enter your password" [ariaAutoComplete]="false"
                                [errorMessage]="getFormErrorMessage(f.password)" [isRequired]="true"
                                [inputType]="getFormInputType(f.password)"></antim-autoware-input>
                            <span (click)="showHidePassword()" class="d-non">
                                <i class="fa fa-eye eye_icon loginEye"
                                    [ngClass]="{'fa-eye': showPassword != false, 'fa-eye-slash': showPassword != true }"></i>
                            </span>
                        </div>
                    </div>
                    <!-- End: Input field for enter password -->

                    <!-- Begin: Submit button -->
                    <antim-autoware-button type="submit" label="Sign In" btnType="primary" class="w-100"
                        [buttonStyle]="{width: '100%'}" [disabled]="isSubmitting || !loginForm.valid"
                        [isSubmitted]="isSubmitting"></antim-autoware-button>
                    <!-- End: Submit button -->
                </form>

            </antim-autoware-card>
        </div>
    </div>
</div>